import { UnstyledButton, UnstyledButtonProps } from "@mantine/core";

import { IconLayoutSidebarLeftExpand, IconLayoutSidebarRightExpand } from "@tabler/icons-react";

interface NavBarToggleButtonProps extends UnstyledButtonProps {
  collapsed: boolean;
  toggle: () => void;
}

export default function NavBarToggleButton({
  collapsed,
  toggle,
  ...props
}: NavBarToggleButtonProps) {
  return (
    <UnstyledButton display="flex" onClick={toggle} {...props}>
      {collapsed ? (
        <IconLayoutSidebarLeftExpand size={24} aria-label="Expand navbar" />
      ) : (
        <IconLayoutSidebarRightExpand size={24} aria-label="Collapse navbar" />
      )}
    </UnstyledButton>
  );
}
